import { X } from 'lucide-react';

interface HelpModalProps {
  open: boolean;
  onClose: () => void;
}

const shortcuts = [
  ['V', 'Select'], ['W', 'Wall'], ['Q', 'Room'], ['F', 'Slab'], ['B', 'Box'], ['L', 'Line'],
  ['D', 'Door'], ['N', 'Window'], ['P', 'Push / Pull'], ['M', 'Move'], ['R', 'Rotate'], ['S', 'Scale'],
  ['G', 'Paint'], ['T', 'Measure'], ['E', 'Eraser'], ['Delete', 'Delete selection'], ['Ctrl D', 'Duplicate'],
  ['Ctrl Z / Y', 'Undo / redo'], ['Esc', 'Cancel current action'],
];

export function HelpModal({ open, onClose }: HelpModalProps): JSX.Element | null {
  if (!open) return null;
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="help-modal" role="dialog" aria-modal="true" aria-labelledby="help-title">
        <header>
          <div><small>ConstructCanvas Studio</small><h2 id="help-title">Modelling guide</h2></div>
          <button type="button" className="icon-button" onClick={onClose} aria-label="Close help"><X size={19} /></button>
        </header>
        <div className="help-content">
          <section>
            <h3>Navigation</h3>
            <p>Middle-drag to orbit, right-drag to pan, and use the wheel to zoom. Double-click the viewport to frame the current selection.</p>
            <h3>Construction workflow</h3>
            <p>Draw a Room or individual Walls, then add hosted Doors and Windows by clicking the wall. Openings are retained as semantic wall data and included in live quantities.</p>
            <h3>Precision</h3>
            <p>Use the exact-value box in the lower-right after selecting an element. Inputs accept metres, millimetres, centimetres, feet and inches.</p>
            <h3>Files</h3>
            <p>Save the editable model as <code>.ccmodel</code>. GLB, OBJ and STL export derived geometry for other 3D applications. Browser autosave protects the current model locally.</p>
          </section>
          <section>
            <h3>Keyboard shortcuts</h3>
            <div className="shortcut-grid">
              {shortcuts.map(([key, action]) => <div key={`${key}-${action}`}><kbd>{key}</kbd><span>{action}</span></div>)}
            </div>
          </section>
        </div>
        <footer>
          <span className="release-badge">Engineering prototype v0.1</span>
          <button type="button" className="primary-button" onClick={onClose}>Start modelling</button>
        </footer>
      </section>
    </div>
  );
}
